module.exports = __webpack_public_path__ + "static/media/agricultural6.9a2a2b77.jpg";